/**
 * Transform gig data from current format to shared package format
 * @param {Object} gig - Current gig object
 * @param {Object} trackingProps - Tracking properties
 * @returns {Object} Transformed gig object for shared package
 */
export const transformGigData = (gigs, trackingProps) =>
    gigs.map((gig) => ({
        gig_id: gig.id,
        u_id: gig.id,
        title: gig.title,
        type: 'gig',
        status: gig.status,

        price_i: gig.price,

        buying_review_rating: gig.rating || 0,
        buying_review_rating_count: gig.ratingsCount || gig.ratingCount || 0,

        seller_id: gig.seller?.id || gig.seller?.username || '',
        seller_name: gig.seller?.username || '',
        seller_img: gig.seller?.profilePhoto || '',
        seller_display_name: gig.seller?.username || '',

        category_id: gig.categoryId || 0,
        sub_category_id: gig.subCategoryId || 0,
        nested_sub_category_id: gig.subCategoryId || 0,

        sellerQueryParams: trackingProps,

        assets: [
            {
                type: 'ImageAsset',
                cloud_img_main_gig: gig.thumbnail || '',
                title: gig.title || '',
            },
        ],

        cached_slug: gig.url?.replace(/^\//, '') || '',
        impressionId: `gig_${gig.id || 0}`,
    }));
